// Generated by ReScript, PLEASE EDIT WITH CARE

import WildcardsLoader from "./WildcardsLoader";

var make = WildcardsLoader;

export {
  make ,
  
}
/* make Not a pure module */
